import buildMatchPatternFn from '../../../_lib/buildMatchPatternFn/index';
import buildMatchFn from '../../../_lib/buildMatchFn/index';

const matchOrdinalNumberPattern = /^(\d+)(ला|रा|था)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(बी|ए)/i,
  abbreviated: /^(बीसी|एडी)/i,
  wide: /^(ईसा पूर्व|ईसा के बाद)/i,
};
const parseEraPatterns = {
  any: [/(^बी|^बीसी|^ईसा पूर्व)/i, /(^ए|^एडी|^ईसा के बाद)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^प्रश्न [1234]/i,
  wide: /^(1 ली तिमाही|2 सरी तिमाही|3 सरी तिमाही|4 थी तिमाही)/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/प्रश्न 1/i, /प्रश्न 2/i, /प्रश्न 3/i, /प्रश्न 4/i],
  wide: [/1 ली तिमाही/i, /2 सरी तिमाही/i, /3 सरी तिमाही/i, /4 थी तिमाही/i],
};

const matchMonthPatterns = {
  narrow: /^(एफ|एम|आई|जे|ए|एस|ओ|एन|डी)/i,
  abbreviated:
    /^(जनवरी|फरवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्टूबर|नवंबर|दिसंबर)/i,
  wide: /^(जनवरी|फरवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्टूबर|नवंबर|दिसंबर)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^जे/i,
    /^एफ/i,
    /^एम/i,
    /^ए/i,
    /^एम/i,
    /^आई/i,
    /^jजे/i,
    /^ए/i,
    /^एस/i,
    /^ओ/i,
    /^एन/i,
    /^डी/i,
  ],
  abbreviated: [
    /^जनवरी/i,
    /^फरवरी/i,
    /^मार्च/i,
    /^अप्रैल/i,
    /^मई/i,
    /^जून/i,
    /^जुलाई/i,
    /^अगस्त/i,
    /^सितंबर/i,
    /^अक्टूबर/i,
    /^नवंबर/i,
    /^दिसंबर/i,
  ],
  wide: [
    /^जनवरी/i,
    /^फरवरी/i,
    /^मार्च/i,
    /^अप्रैल/i,
    /^मई/i,
    /^जून/i,
    /^जुलाई/i,
    /^अगस्त/i,
    /^सितंबर/i,
    /^अक्टूबर/i,
    /^नवंबर/i,
    /^दिसंबर/i,
  ],
};

const matchDayPatterns = {
  narrow: /^(एस|एम|टी|डब्ल्यू|एफ)/i,
  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  abbreviated: /^(रवि|सोम|मंगल|बुध|वृहस्पति|शुक्र|शनि)/i,
  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|वृहस्पतिवार|शुक्रवार|शनिवार)/i,
};
const parseDayPatterns = {
  narrow: [/^एस/i, /^एम/i, /^टी/i, /^डब्ल्यू/i, /^टी/i, /^एफ/i, /^एस/i],
  short: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
  abbreviated: [
    /^रवि/i,
    /^सोम/i,
    /^मंगल/i,
    /^बुध/i,
    /^वृहस्पति/i,
    /^शुक्र/i,
    /^शनि/i,
  ],
  any: [
    /^रविवार/i,
    /^सोमवार/i,
    /^मंगलवार/i,
    /^बुधवार/i,
    /^वृहस्पतिवार/i,
    /^शुक्रवार/i,
    /^शनिवार/i,
  ],
};

const matchDayPeriodPatterns = {
  narrow: /^(ए|पी|एमआइ|एन|सुबह|दोपहर|शाम|रात)/i,
  abbreviated:
    /^(पूर्वाह्न|अपराह्न|मध्यरात्रि|मध्याह्न|सुबह|दोपहर के बाद|शाम|रात्रि)/i,
  wide: /^(पूर्वाह्न|अपराह्न|मध्यरात्रि|मध्याह्न|सुबह|दोपहर|शाम|रात)/i,
};
const parseDayPeriodPatterns = {
  narrow: {
    am: /ए/i,
    pm: /पी/i,
    midnight: /एमआइ/i,
    noon: /एन/i,
    morning: /सुबह/i,
    afternoon: /दोपहर/i,
    evening: /शाम/i,
    night: /रात/i,
  },
  abbreviated: {
    am: /पूर्वाह्न/i,
    pm: /अपराह्न/i,
    midnight: /मध्यरात्रि/i,
    noon: /मध्याह्न/i,
    morning: /सुबह/i,
    afternoon: /दोपहर के बाद/i,
    evening: /शाम/i,
    night: /रात्रि/i,
  },
  wide: {
    am: /पूर्वाह्न/i,
    pm: /अपराह्न/i,
    midnight: /मध्यरात्रि/i,
    noon: /मध्याह्न/i,
    morning: /सुबह/i,
    afternoon: /दोपहर/i,
    evening: /शाम/i,
    night: /रात/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any',
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    },
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'wide',
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any',
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'wide',
  }),
};

export default match;
